import { css, cx } from '@emotion/css';
import { Color, Display, Font, JustifyContent, Spacing, TextAlign } from 'src/styles';

export const description = cx(
  css`
    ${Font.sm}
    color: ${Color.Gray7};
    ${Spacing.mb32}
    ${TextAlign.center}
  `,
);

export const disclaimer = cx(
  css`
    ${Font.sm}
    color: #5c6572;
    ${Spacing.mt20}
  `,
);

export const title = css`
  ${Font.lg}
  ${Display.flex}
  ${JustifyContent.center}
  ${Spacing.my12}
`;

export const subtitle = css`
  ${Font.md}
  ${Display.flex}
  ${JustifyContent.center}
  color: ${Color.Gray7};
  ${Spacing.my12}
`;

export const offerName = cx(
  css`
    font-weight: bold;
    font-size: 18px;
    line-height: 26px;
    color: ${Color.Gray10};
  `,
);

export const offerLogo = css`
  width: 32px;
  height: 32px;
  margin-right: 12px;
`;
